const permissions = [
  {
    key: "admin_perm",
    label: "Administrator",
  },
  {
    key: "user_perm",
    label: "Manage Staff",
  },
  {
    key: "location_perm",
    label: "Delivery Locations",
  },
  {
    key: "product_perm",
    label: "Product Catalog",
  },
  {
    key: "order_perm",
    label: "Manage Orders",
  },
  {
    key: "accounting_perm",
    label: "Settlements",
  },
  {
    key: "faq_perm",
    label: "FAQ",
  },
  {
    key: "feedback_perm",
    label: "Feedback & Ratings",
  },
  {
    key: "help_perm",
    label: "Help & Support",
  },
  {
    key: "log_perm",
    label: "Logs",
  },
  {
    key: "dashboard_perm",
    label: "Dashboard",
  },
  {
    key: "delivery_perm",
    label: "Delivery Executive",
  },
];

export default permissions;
